import * as React from "react";
 export default class RolEkranIslemleri extends React.Component {
    render() {
        return (
            <div>
                Rol Ekran İşlemleri
            </div>
        );
    }
}